import { SizeTransition } from './transition.size.js';
import { jsx } from 'react/jsx-runtime';

function CollapsibleTransition(props) {
  return /*#__PURE__*/jsx(SizeTransition, {
    ...props,
    getMaxSizeInPx: (target, stage) => {
      const defaultMaxSize = defaultGetMaxSizeInPx(target);
      const explicitMaxSize = props.getMaxSizeInPx?.(target, stage);
      return {
        width: Math.min(defaultMaxSize.width, explicitMaxSize?.width ?? Infinity),
        height: Math.min(defaultMaxSize.height, explicitMaxSize?.height ?? Infinity)
      };
    }
  });
}
function defaultGetMaxSizeInPx(target) {
  const computedStyles = window.getComputedStyle(target);
  const boundingBox = target.getBoundingClientRect();
  const maxHeight = computedStyles.maxHeight === "none" || !computedStyles.maxHeight.includes("px") ? window.innerHeight - boundingBox.top : Math.min(parseFloat(computedStyles.maxHeight), window.innerHeight - boundingBox.top);
  const maxWidth = computedStyles.maxWidth === "none" || !computedStyles.maxWidth.includes("px") ? window.innerWidth - boundingBox.left : Math.min(parseFloat(computedStyles.maxWidth), window.innerWidth - boundingBox.left);
  return {
    width: maxWidth,
    height: maxHeight
  };
}

export { CollapsibleTransition };
//# sourceMappingURL=transition.collapsible.js.map
